import * as React from "react";
import { useTheme, styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import Container from "../../../common/Container";
import banner1 from "../../../assets/banner/banner1.jpg";
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const ColorButton = styled(Button)(() => ({
  color: "#fff",
  width: 225,
  height: 65,
  fontWeight: 700,
  fontSize: "16px",
  textTransform: "capitalize",
  backgroundColor: "#00AEEF",
  borderColor: "#00AEEF",
  "&:hover": {
    color: "#fff",
    backgroundColor: "#3E4095",
    borderColor: "#3E4095",
  },
}));

const images = [
  {
    label: "banner_image1",
    imgPath: banner1,
    title: "We Are Into Sustainable Aquaculture and Fisheries Business",
    subtitle:
      "Our mission is to increase knowledge, teach skills to achieve high productivity in Aquaculture and Fisheries for a sustainable future.",
  },
];

function Banner() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ flexGrow: 1 }} marginTop={{ xs: "5%", sm: "0%" }}>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={5000}
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box>
                <Box display={{ xs: "none", sm: "inline" }}>
                  <Box
                    component="img"
                    height={{ xs: "95vh", sm: "110vh" }}
                    sx={{
                      objectFit: "cover",
                      position: "relative",
                      overflow: "hidden",
                      width: "100%",
                    }}
                    src={step.imgPath}
                    alt={step.label}
                  />
                </Box>
                <Container>
                  <Box
                    paddingBottom={"3%"}
                    position={"absolute"}
                    top={{ xs: "15%", sm: "20%" }}
                    marginLeft={{ xs: "0%", sm: "0%" }}
                    width={{ xs: "100%", sm: "70%" }}
                    display={{ xs: "none", sm: "block" }}
                  >
                    {" "}
                    <Typography
                      variant="h2"
                      color="#fff"
                      fontWeight={800}
                      padding={{ xs: "0%", sm: "0% 15% 0% 0%" }}
                      textAlign={"left"}
                    >
                      {step.title}
                    </Typography>
                    <Typography
                      variant="h6"
                      color="#fff"
                      fontWeight={400}
                      padding={{ xs: "0%", sm: "2% 15% 0% 0%" }}
                      textAlign={"left"}
                    >
                      {step.subtitle}
                    </Typography>
                    <Box
                      marginTop={"2%"}
                      display={"flex"}
                      justifyContent={"left"}
                    >
                      <ColorButton
                        component={"a"}
                        variant="contained"
                        size="medium"
                        href={"/about-us"}
                      >
                        Read More
                      </ColorButton>
                    </Box>
                  </Box>
                </Container>
                <Container>
                  <Box
                    paddingBottom={"3%"}
                    // position={"absolute"}
                    // top={{ xs: "60%", sm: "32%" }}
                    marginLeft={{ xs: "0%", sm: "2%" }}
                    width={{ xs: "100%", sm: "85%" }}
                    display={{ xs: "block", sm: "none" }}
                  >
                    {" "}
                    <Typography
                      variant="h2"
                      color="#fff"
                      fontWeight={800}
                      padding={{ xs: "2% 2% 0% 0%", sm: "1% 1% 1% 18%" }}
                      textAlign={"left"}
                    >
                      {step.title}
                    </Typography>
                    <Typography
                      variant="h6"
                      color="#fff"
                      fontWeight={400}
                      padding={{ xs: "2% 5% 0% 0%", sm: "% 1% 1% 18%" }}
                      textAlign={"left"}
                    >
                      {step.subtitle}
                    </Typography>
                    <Box margin={{ xs: "6% 0%", sm: "3%" }}>
                      <ColorButton
                        component={"a"}
                        variant="contained"
                        size="medium"
                        href={"/about-us"}
                      >
                        Read More
                      </ColorButton>
                    </Box>
                  </Box>
                </Container>
              </Box>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
    </Box>
  );
}

export default Banner;
